<script>
  import { onMount } from "svelte";
  let show = false;
  onMount(() => {
    setTimeout(() => {
      show = true;
    }, 300);
  });
  export let obj;
</script>

<iframe class="h-full w-full transition-all duration-500" class:op-0={!show} src={obj.href} frameborder="0" title={obj.title} />
